import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    height: "100%",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      height: "100px",
    },
    "& .label": {
      position: "absolute",
    },
    "& .uploadButton": {
      position: "absolute",
      top: "35px",
      left: "-5px",
    },
    "& .thumbnail": {
      position: "absolute",
      left: "150px",
      top: "-8px",
      width: "100px",
    },
  },
  label: {
    marginBottom: theme.spacing(0),
    color: "#000",
  },
  error: {
    color: "red",
  },
  fileSelected: {
    marginLeft: "5px",
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
    fontWeight: "400",
  },
  fileNotSelected: {
    marginLeft: "5px",
    color: "rgba(0, 0, 0, 0.6)",
    fontWeight: "600",
  },
}));

export default useStyles;
